import { alias, createModelSchema, custom, deserialize, list, serialize, SKIP } from "serializr";
import { Cloneable } from "@/common/Cloneable";
import { RewardModel } from "@/modules/redactor/models/reward/RewardModel";
import { LevelTrackLevelPattern } from "./LevelTrackLevelPattern";
import { LevelTrackLevelField } from "./LevelTrackLevelField";

export class LevelTrackLevel extends Cloneable {

    constructor() {
        super();

        this._container = false;
        this._reward = null;

        this._pattern = [];
        this._fields = [];
    }

    get container() {
        return this._container;
    }

    set container(value) {
        this._container = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get pattern() {
        return this._pattern;
    }

    set pattern(value) {
        this._pattern = value;
    }

    get fields() {
        return this._fields;
    }

    set fields(value) {
        this._fields = value;
    }

    valid() {
        if (this.container === undefined || this.container === null || typeof this.container !== 'boolean') {
            return false;
        }

        if (!this.reward || !this.reward.valid()) {
            return false;
        }

        if (!this.pattern || this.pattern.length === 0) {
            return false;
        }

        if (this.pattern.some(v => !v.valid())) {
            return false;
        }

        if (!this.fields || this.fields.length === 0) {
            return false;
        }

        if (this.fields.some(v => !v.valid())) {
            return false;
        }


        return true;
    }

    empty() {
        return !this.container && (!this.reward || this.reward.empty()) && (!this.pattern || this.pattern.length === 0) && (!this.fields || this.fields.length === 0);
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LevelTrackLevel());
        } else if (target instanceof LevelTrackLevel) {
            return super.clone(target);
        } else {
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(LevelTrackLevel, v) : SKIP;
        }, (v) => {
            return deserialize(LevelTrackLevel, v);
        });
    }
}

createModelSchema(LevelTrackLevel, {
    _container: alias("container", toBoolean()),
    _reward: alias("reward", RewardModel.schema()),

    _pattern: alias("pattern", list(LevelTrackLevelPattern.schema())),
    _fields: alias("fields", list(LevelTrackLevelField.schema())),
});

function toBoolean() {
    return custom(
        (value) => Boolean(value),
        (value) => Boolean(value),
    );
}
